<kanzi-ui-main-card
  title="{{ 'locations.create_title' | translate }}"
  description="{{ 'locations.create_description' | translate }}"
>
  <ng-template kTemplate="rightTopContent">
    @if (isLoadFileMasterLocations) {
    <button
      pButton
      pRipple
      type="button"
      (click)="downloadFormat()"
      class="p-button-raised p-button-text mr-2 mb-2"
      icon="fa fa-download"
      label="{{ 'Descargar Formato' | translate }}"
    ></button>
    } @if (isLoadFileMasterLocations) {
    <button
      type="button"
      class="p-button-raised p-button-help mr-2 mb-2"
      (click)="showDialogFileAdd()"
      pButton
      pRipple
      label="{{ 'Cargar por archivo' | translate }}"
      icon="pi pi-upload"
    ></button
    >}
  </ng-template>
  <app-location-form></app-location-form>
</kanzi-ui-main-card>

<kanzi-apes-locations-file
  [displayDialog]="isDisplayModal"
  [customer]="customerSelected$ | async"
  (closeDialog)="closeModal($event)"
  (submitData)="upLoadMasterFile($event)"
>
</kanzi-apes-locations-file>
